import { render, staticRenderFns } from "./InvoiceInformation.vue?vue&type=template&id=61a71a43&scoped=true&"
import script from "./InvoiceInformation.vue?vue&type=script&lang=js&"
export * from "./InvoiceInformation.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/open_booking_section.css?vue&type=style&index=0&id=61a71a43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a71a43",
  null
  
)

export default component.exports